// extracted by mini-css-extract-plugin
export default {"discountBanner":"qaa","topheader":"raa","navleft":"saa","navflexelem":"taa","navright":"uaa","fixedtop":"vaa","abstop":"waa","subdesc":"xaa","smallscreennav":"yaa","nav_hidden":"zaa","cancel_link":"Aaa","bottomnavcontainer":"Baa","fixedbottom":"Caa","animatedbottom":"Eaa","appear-bottom":"Faa","delayedbottom":"Gaa","retakebtn":"Haa","long_banner":"Iaa","nofixed":"Jaa"};
    if(module.hot) {
      // 1714422958245
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  